import React, { Component } from 'react';
import { Link } from "react-router-dom";
import {
  Table
} from "react-bootstrap";
import $ from 'jquery';
import { apiUrl} from'../Config/Config';
import axios from 'axios';
import Header from '../Layouts/Header';
import { lang } from '../Helpers/lang';
import Select from 'react-select';
import MenuSidebar from '../Layouts/MenuSidebar';
import Pagination from "react-js-pagination";

import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";

/* import { GET_FONTLIST, GET_DELETEFONT } from '../../actions'; */

class List extends Component {
  
  constructor(props)
  {
    super(props); 
    this.state = {
      fontlist:'',
      editable: false,
      priorityid:'',
      priorityvalue:'',
      activePage: 1,
      totalRecord: '',
      search_all:'',
      selectid:'',

      selectedFilOption:'',
      selectedFilvalue:'',
    };

    

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

   
   componentDidMount() {
      document.title = PageTitle('Fonts');
      if(localStorage.getItem('admin_id') === null){
      this.props.history.push('/');
      }
      this.listloadData()
   }
listloadData(postobject=''){
  var admin_id = localStorage.getItem("admin_id");
  var qs = require('qs');
  if(postobject!=''){
    var postobject=postobject;
  }else{
    var postobject = {
      activePage: 1,
      search_all: '',
      admin_id: admin_id
    };
  }
  
axios.post(apiUrl+"font/list",qs.stringify(postobject)).then(res => {
 
 if(res.data.status === 'success'){
  this.setState({ totalRecord : res.data.records_count, fontlist: res.data.fontlist}, function() {
    this.fontlist();
  });
 }
 else{
  this.setState({  fontlist: '', totalRecord: 0}, function() {
    this.fontlist();
  });
 }
}); 
}
   handlePageChange(pageNumber) {
     // console.log(`active page is ${pageNumber}`);
      this.setState({activePage: pageNumber});
      var qs = require('qs');
      var admin_id = localStorage.getItem("admin_id");
      var postobject = {
        activePage: pageNumber,
        search_all: this.state.search_all,
        admin_id: admin_id
      };
      this.listloadData(postobject)
    }

    handleInputChange(event) {
    const {name, value} = event.target;      
    this.setState({
      [name]: value
    });
    var admin_id = localStorage.getItem("admin_id");
    var postobject = {
      activePage: 1,
      search_all: value,
      admin_id: admin_id
    };
    this.listloadData(postobject)
  }
   handleFormSubmit = () => {
        
          this.setState({Loading:true});
          var qs = require('qs');
          const formPayload = this.state;
          var admin_id = localStorage.getItem("admin_id");
          var postObject = {             
              activePage : 1,
              search_all : formPayload.search_all,
              filterVal : formPayload.selectedFilvalue,
              admin_id  : admin_id         
          };
          //console.log(postObject);
          this.listloadData(postObject)
        
    }
    confirmPopup = (id) => {
      var status = status;
      if(status == 'inactive'){
        status = "active";
      }else{
        status = "inactive";
      }
      this.setState({selectid: id})	
      $('.confirm-action').addClass('show');		
    }
    
    Confirmstatus = (confirmstatus) => {
      if(confirmstatus == 'yes'){
        this.deletefont();
        $('.confirm-action').removeClass('show');
      }else{
        $('.confirm-action').removeClass('show');	
      }
        
    }


  deletefont(){
        var qs = require('qs');
        var admin_id = localStorage.getItem("admin_id");
        var postObject = {
          font_id  :this.state.selectid,
          admin_id  : admin_id
        };

      axios.post(apiUrl+"font/delete",qs.stringify(postObject)).then(res => {
     
        if(res.data.status === 'success'){
          $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
          setTimeout(
          function() {
          $('.success_message').html('');
          }
          .bind(this),
          3000
          );

          this.listloadData()
            }
      }); 
}
  fontlist() {
    var fontlist = this.state.fontlist;
    if (fontlist != "undefined" && fontlist != null) {
        if (Object.keys(fontlist).length > 0) {
          const fontlistDetails = fontlist.map(
            (fontlist, Index) => {
              let sno = Index+1;
              if(fontlist.tf_status == 'A'){
                var status = 'Active';
              }else{
                  status = 'Inactive';
              }
              return (
                <tr key={fontlist.tf_id}>
                <td>{sno}</td>
                  <td>
                  {fontlist.tf_name}
                  </td>
                  <td>{status}</td>
                  <td>
                   <Link to={{ pathname: '/font-edit/'+fontlist.tf_id}} className="" title="edit">  <i className="ft-edit-3" aria-hidden="true"></i></Link>
                     <Link onClick={this.confirmPopup.bind(this,fontlist.tf_id)} className="" title="delete">  <i className="ft-trash-2" aria-hidden="true"></i></Link>
                  </td>
                </tr>
              );
            }
          );
          return fontlistDetails ;
        }  else {
        return (
          <tr>
            <td colspan="6" className="v-align-nr">
              No Result
            </td>
          </tr>
        );
      }
    }
  } 
  handleFilChange = (selOption) => {       	
    this.setState({selectedFilOption:selOption})
    this.setState({  selectedFilvalue : selOption.value},function(){
      this.handleFormSubmit()
    });
  };
  
  render() {
    return (
      <div className="wrapper"> 
  <div className="confirm-action">
			<p>Are you sure! you want to delete the font?</p>
			<a href="javascript://" onClick={this.Confirmstatus.bind(this, "yes")} className="btn">Yes</a>
			<a href="javascript://" onClick={this.Confirmstatus.bind(this, "no")} className="btn">No</a>
		</div>
    <Header />
    <MenuSidebar currentpage="fonts"  currentTab="common" />  
      
      <div className="content"> 
        <div className="content-wrapper">
              <div class="content-wrapper-before"></div>
            <div className="car-listing-wrap leaa-admin-head card">
            <div className="success_message"></div>
              <div className="listing-header">
                <div className="title">
                  <h3>{this.state.totalRecord} Font{this.state.totalRecord>1 ? 's' : ''} </h3>
                </div>
                <div className='listing-header-right-sec d-flex justify-content-end gap-2 w-100'>
                  <div className="search-list">
                    <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} >     
                    <div className="input_search">
                          <div className="search-inner search_input">
                            <input type="text" name="search_all" onChange={this.handleInputChange} className="form-control" value={this.state.search_all} placeholder="Search" /> 
                            <button className="" type="submit">Submit</button>
                            <div className="erroremail"></div>                        
                          </div>
                          <div className="search-inner search_select">
                            <Select name="category" options={lang.common.status_filter_option} 
                              //onChange={this.handleInputChange}
                              onChange={this.handleFilChange.bind(this)}
                            />
                          </div> 
                    </div>
                  </form>
                  </div>
                  <div className="add_button">  
                    <a className="primary-btn" href='/font-add'>Add</a> 
                  </div>
                </div>
              </div>            
              {/*<div className="statusmessage"></div>*/}

              <div className="car-listing-row">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>S.NO</th>
                      <th>Font Name</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>{this.fontlist()}</tbody>
                </Table>
                 <div className="text-center">
            <Pagination
            activePage={this.state.activePage}
            itemsCountPerPage={10}
            totalItemsCount={this.state.totalRecord}
            pageRangeDisplayed={5}
            onChange={this.handlePageChange.bind(this)}
            />
          </div>
              </div>

            </div> 
        </div>  
      </div>
      
    </div>
    );
  }
}


export default List;